module.exports = __webpack_public_path__ + "img/LOGO-PNG-11.cd43451f.png";